<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__landingpages}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <!--          <el-input v-model="dataForm.advertiserId" placeholder="账户id" clearable></el-input>-->
          <el-select
            v-model="dataForm.advertiserId"
            filterable
            clearable
            placeholder="请选择账户"
          >
            <el-option
              v-for="item in advertisers"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="dataForm.companyId"
            filterable
            clearable
            placeholder="请选择公司"
          >
            <el-option
              v-for="item in companys"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="dataForm.operationId"
            filterable
            clearable
            placeholder="请选择运营机构"
          >
            <el-option
              v-for="item in operations"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="dataForm.channelId"
            filterable
            clearable
            placeholder="请选择渠道"
          >
            <el-option
              v-for="item in channels"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
        <!--        <el-form-item>-->
        <!--          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>-->
        <!--        </el-form-item>-->
        <el-form-item>
          <el-button
            v-if="$hasPermission('sys:landingpages:save')"
            type="primary"
            @click="addOrUpdateHandle()"
            >{{ $t("add") }}</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="$hasPermission('sys:landingpages:delete')"
            type="danger"
            @click="deleteHandle()"
            >{{ $t("deleteBatch") }}</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
      >
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="id"
          label="id"
          header-align="center"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="advertiserId"
          label="账户ID"
          header-align="center"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="advertiserName"
          label="账户名称"
          header-align="center"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="loanType"
          label="贷款标识"
          header-align="center"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="logo"
          label="腾讯/百度落地页"
          header-align="center"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="standard"
          label="落地页标识"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.standard == 1" size="small">标准</el-tag>
            <el-tag v-else type="warning" size="small">非标准</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="address"
          label="投放城市"
          header-align="center"
          align="center"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column
          prop="standard"
          label="公司运营方式"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.standard == 1" size="small">标准</el-tag>
            <el-tag v-else type="warning" size="small">非标准</el-tag>
          </template>
        </el-table-column>
        <!-- standard -->

        <el-table-column
          prop="isFixed"
          label="是否直投"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isFixed == 1" size="small">直投</el-tag>
            <el-tag v-else type="warning" size="small">非直投</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="落地页名称"
          header-align="center"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="url"
          label="页面地址"
          header-align="center"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="channelName"
          label="渠道"
          header-align="center"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="operationName"
          label="运营机构"
          header-align="center"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="characteristic"
          label="开发形式"
          header-align="center"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="pageId"
          label="页面Id"
          header-align="center"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="companyNames"
          label="所属公司"
          header-align="center"
          align="center"
          :formatter="convertCompanyNames"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          header-align="center"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <!--        <el-table-column prop="status" label="状态（开1、关0）" header-align="center" align="center"></el-table-column>-->
        <el-table-column
          prop="createTime"
          label="创建时间"
          header-align="center"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          :label="$t('handle')"
          fixed="right"
          header-align="center"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              v-if="$hasPermission('sys:landingpages:update')"
              type="text"
              size="small"
              @click="addOrUpdateHandle(scope.row.id)"
              >{{ $t("update") }}</el-button
            >
            <el-button
              v-if="$hasPermission('sys:landingpages:delete')"
              type="text"
              size="small"
              @click="deleteHandle(scope.row.id)"
              >{{ $t("delete") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update
        v-if="addOrUpdateVisible"
        ref="addOrUpdate"
        @refreshDataList="getDataList"
      ></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import AddOrUpdate from "./landingpages-add-or-update";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/sys/landingpages/page",
        getDataListIsPage: true,
        exportURL: "/sys/landingpages/export",
        deleteURL: "/sys/landingpages",
        deleteIsBatch: true,
      },
      companys: [],
      operations: [],
      channels: [],
      advertisers: [],
      dataForm: {
        advertiserId: "",
        companyId: "",
        operationId: "",
        channelId: "",
      },
    };
  },
  components: {
    AddOrUpdate,
  },
  created() {
    if (this.mixinViewModuleOptions.createdIsNeed) {
      this.query();
      this.getCompanysOptions();
      this.getOperatorsOptions();
      this.getchannelsOptions();
      this.getAdvertisersOptions();
    }
  },
  methods: {
    convertCompanyNames(row, column) {
      let companyNamesList = row.companyNames;
      if (companyNamesList == null || companyNamesList.length == 0) {
        return null;
      }
      let companyNames = "";
      for (let i = 0; i < companyNamesList.length; i++) {
        companyNames = companyNames + companyNamesList[i] + ",";
      }
      companyNames = companyNames.substring(0, companyNames.length - 1);
      return companyNames;
    },
    //初始化公司下拉框中的选项
    async getCompanysOptions() {
      this.$http
        .get(`/sys/companies/list`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.companys = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.companys.push({ label: element.name, value: element.id });
            });
          }
        })
        .catch(() => {});
    },
    //初始化渠道下拉框中的选项
    async getchannelsOptions() {
      this.$http
        .get(`/sys/channels/list`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.channels = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.channels.push({ label: element.name, value: element.id });
            });
          }
        })
        .catch(() => {});
    },
    //初始化公司下拉框中的选项
    async getOperatorsOptions() {
      this.$http
        .get(`/sys/operations/list`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.operations = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.operations.push({ label: element.name, value: element.id });
            });
          }
        })
        .catch(() => {});
    },
    //初始化广告主账户下拉框中的选项
    async getAdvertisersOptions() {
      this.$http
        .get(`/sys/rdadvertiser/list`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.advertisers = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.advertisers.push({
                label: element.advertiserName,
                value: element.advertiserId,
              });
            });
          }
        })
        .catch(() => {});
    },
  },
};
</script>
